import { getConfig, getErrorMessage, klinikenApi } from "@/api";
import { openDialog } from "@/utils";

type ValideradFras = {
    [key: string]: boolean;
};

export type ValideraFraserCollection = Map<string, Map<string, boolean>>;

const defaultGetFraserApiUrl = "/core/templates/";

export const getFraser = async ({ apiUrl = defaultGetFraserApiUrl } = { apiUrl: defaultGetFraserApiUrl }) => {
    try {
        const response = await klinikenApi.get(apiUrl, getConfig());

        if (response.status === 200) {
            const { data } = response;

            return (
                data?.map(({ description, field_name }: { description: string; field_name: string }) => ({
                    value: field_name,
                    text: description,
                })) ?? []
            );
        }
    } catch (error) {
        openDialog(getErrorMessage(error), "error");
    }
};

export const valideraFraser = async ({
    anmalanIds,
}: {
    anmalanIds: string[];
}): Promise<ValideraFraserCollection | undefined> => {
    try {
        /* Expected that backend responds with a list of objects that has a key with the name of the phrase and a value of 
        true or false corresponding to whether that phrase has a value or not. [{pat_namn: true},{pat_fornamn: false}]
        */
        if (anmalanIds.length === 1) {
            const response = await klinikenApi.get(`/operation/validerafraser/${anmalanIds[0]}/`, getConfig({}));

            return new Map([
                [
                    anmalanIds[0],
                    new Map(
                        response.data.map((value: ValideradFras) => {
                            const entries = Object.entries(value);

                            return [entries[0][0], entries[0][1]];
                        })
                    ),
                ],
            ]);
        }

        const result = await Promise.all(
            anmalanIds.map((id) => {
                return (async (): Promise<[string, Map<string, boolean>]> => {
                    const response = await klinikenApi.get(`/operation/validerafraser/${id}/`, getConfig({}));

                    return [
                        id,
                        new Map<string, boolean>(
                            response.data.map((value: ValideradFras) => {
                                const entries = Object.entries(value);

                                return [entries[0][0], entries[0][1]];
                            })
                        ),
                    ];
                })();
            })
        );

        return new Map(
            result.map((data) => {
                return [data[0], data[1]];
            })
        );
    } catch (error) {
        openDialog(getErrorMessage(error), "error");
    }
};

export const mapAnmalanPatients = (anmalningar: any[]) => {
    return new Map(
        anmalningar.map((anmalan) => {
            const { patient_display } = anmalan;
            return [
                anmalan.id,
                `${patient_display.personId_formatted} ${patient_display.fornamn} ${patient_display.efternamn}`,
            ];
        })
    );
};
